import { useQueries } from "@tanstack/react-query";
import queryFactory from "./queryFactory";

export default (claimIds: string[]) => {
  const queries = useQueries({
    queries: claimIds.map(claimId => queryFactory.claimInfoRequests(claimId)),
  });

  const isLoading = queries.some(query => query.isLoading);
  const error = queries.find(query => query.error)?.error;

  // Group results by claim ID for easy access
  const resultsByClaimId = queries.reduce(
    (acc, query, index) => {
      const claimId = claimIds[index];
      if (claimId) {
        acc[claimId] = {
          data: query.data,
          isLoading: query.isLoading,
          error: query.error,
        };
      }
      return acc;
    },
    {} as Record<string, { data: any; isLoading: boolean; error: any }>,
  );

  return {
    resultsByClaimId,
    isLoading,
    error,
  };
};
